module.exports = __webpack_public_path__ + "img/1363272522.0ca2a786.jpg";